import { TrendingUp, TrendingDown, Minus } from 'lucide-react'

interface TrendIndicatorProps {
  value: number
  label?: string
  /**
   * Sens favorable de la tendance. La flèche suit toujours le signe de la valeur ;
   * la couleur suit « est-ce favorable » : `up` (défaut) = une hausse est bonne (verte),
   * `down` = une baisse est bonne (verte). Valeur 0 → gris « Stable » (inchangé).
   */
  goodDirection?: 'up' | 'down'
  /**
   * Texte du delta à afficher à la place de `{signe}{value}%` (mode « diff » : différence
   * absolue déjà formatée). La flèche et la couleur restent pilotées par le signe de `value`.
   */
  formattedValue?: string
}

export function TrendIndicator({ value, label, goodDirection = 'up', formattedValue }: TrendIndicatorProps) {
  if (value === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-[#555A73]">
        <Minus className="w-3 h-3" strokeWidth={1.25} />
        {label ?? 'Stable'}
      </span>
    )
  }

  const isUp = value > 0
  const isGood = goodDirection === 'up' ? value > 0 : value < 0
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium ${isGood ? 'text-score-excellent' : 'text-score-critical'}`}>
      {isUp ? (
        <TrendingUp className="w-3 h-3" strokeWidth={1.25} />
      ) : (
        <TrendingDown className="w-3 h-3" strokeWidth={1.25} />
      )}
      {formattedValue ?? `${isUp ? '+' : ''}${value}%`}
      {label && <span className="text-[#555A73] font-normal ml-1">{label}</span>}
    </span>
  )
}
